import TableWithSelection from 'components/abmUtils/TableWithSelection'
import { ITableWithSelectionFields } from 'models/TableWithSelection'
import React, { Component } from 'react'
import { Alert, Col } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import _ from 'underscore'
import {
	IPricesAndCostsMassiveUploadTableProps,
	IPricesAndCostsMassiveUploadTableState
} from '../../models/PricesAndCostsMassiveUploadInterface'

class PricesAndCostsMassiveUploadTable extends Component<
	IPricesAndCostsMassiveUploadTableProps,
	IPricesAndCostsMassiveUploadTableState
> {
	obtenerDescripcionSeleccionada(codigo: number, lista: any[]) {
		const opcionSeleccionada = lista.find((opcion) => opcion.codigo === codigo)
		return opcionSeleccionada
			? opcionSeleccionada.codigo
			: 'Opción no encontrada'
	}

	obtenerCampoAEditar(id: string) {
		const { tableFields } = this.props
		const campoAEditar = tableFields.find((campo) => campo.idCampo === id)
		return campoAEditar
	}

	render() {
		const {
			t,
			tableFields,
			fields,
			gridProdListArray,
			valuesToCalculate,
			handleChangeTable,
			priceTypeData
		} = this.props

		let descripcionSeleccionada

		if (priceTypeData != null && valuesToCalculate != null) {
			const lista = priceTypeData.lista
			const codigo = valuesToCalculate.dato

			if (Array.isArray(lista)) {
				descripcionSeleccionada = this.obtenerDescripcionSeleccionada(
					codigo,
					lista
				)
			}
		}

		const newValues = tableFields.find(
			(field) => field.idCampo === 'nuevo_valor'
		)
		let disableFields = false

		const campoEditado = this.obtenerCampoAEditar(descripcionSeleccionada)

		const newName = campoEditado?.label

		if (newValues && !_.isEmpty(valuesToCalculate)) {
			disableFields = true
			newValues.label = newValues?.label ? 'Nuevo ' + newName : 'Nuevo Valor'
		}

		if (newValues) newValues.editable = disableFields

		const propsTable: ITableWithSelectionFields = {
			disableForm: false,
			tableFields: tableFields,
			fields: gridProdListArray,
			selected: [],
			setSelection: () => {},
			handleChangeTable: handleChangeTable,
			label: 'Ejemplo',
			keyfield: 'niprod',
			checkBox: false,
			hideHeaderButtons: true,
			paginationOption: fields && {
				page_size: fields.page_size,
				page_number: fields.page_number,
				total_count: fields.total_count
			},
			hideScrollX: true,
			hideScrollY: false
		}
		return (
			<Col>
				<Alert variant={'dark'}>
					<b>{t('CRUDS.general_use.items')}</b>
				</Alert>
				<TableWithSelection {...propsTable} />
			</Col>
		)
	}
}

export default withTranslation()(PricesAndCostsMassiveUploadTable)
